import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { classes } from '../utils';
import ROLES from '../../../../constants/roles';
import CustomTooltip from '../../utils/CustomTooltip';

const LastName = (params) => {
  if (params?.data) {
    if (params?.data?.users?.last_name && params?.data?.users?.first_name) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {`${params?.data?.users?.first_name} ${params?.data?.users?.last_name}`}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const CreditDeducted = (params) => {
  const { data } = params;
  if (data) {
    return (
      <Typography variant="body1" fontWeight={400}>
        {data?.credits_deducted ? data?.credits_deducted : '-'}
      </Typography>
    );
  }
};
const DocumentName = (params) => {
  const { data } = params;
  if (data) {
    return (
      <CustomTooltip title={`${data?.invoices?.name}`}>
        <Typography variant="body1" fontWeight={400}>
          {data?.invoices?.name ? data?.invoices?.name : '-'}
        </Typography>
      </CustomTooltip>
    );
  }
  return (
    <Typography variant="body1" fontWeight={400}>
      -
    </Typography>
  );
};
const DocumentTypeRenderer = (params) => {
  if (params?.data) {
    if (params?.data.invoices !== undefined) {
      const getDocumentTypeLabel = () => {
        switch (params?.data?.invoices?.document_type) {
          case 'BS':
            return 'Bank Statement';
          case 'CC':
            return 'Credit Card Statement';
          case 'sales':
            return 'Sales';
          case 'invoice':
            return 'Direct Expenses';
          case 'receipt':
            return 'Indirect Expenses';
          default:
            break;
        }
      };
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.invoices?.document_type ? getDocumentTypeLabel() : '-'}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const ResponsiveFontsize = (params) => {
  if (params?.data) {
    if (params?.data?.invoices && params?.data?.invoices?.status) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.invoices?.status}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const date = (params) => {
  const { data } = params;
  if (data) {
    const formattedDate =
      data?.created_at &&
      moment.utc(data?.created_at).local().format('DD-MM-YYYY HH:mm:ss');

    if (params?.data) {
      return (
        <Box>
          {data.created_at !== undefined && data.created_at !== null ? (
            <Typography variant="body1" fontWeight="400">
              {formattedDate}
            </Typography>
          ) : (
            <Box className={classes.dateValueBox}>
              <Typography>-</Typography>
            </Box>
          )}
        </Box>
      );
    }
  }
};
const UserRole = (params) => {
  const getRoleLabel = (userRole) => {
    if (userRole === ROLES.ADMIN) {
      return 'Admin';
    }
    if (userRole === ROLES.MANAGER) {
      return 'Manager';
    }
    return 'Member';
  };
  if (params?.data) {
    if (params?.data?.users?.role?.role !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {getRoleLabel(params?.data?.users?.role?.role)}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const creditsHistoryColumnDef = (
  gridSettingData,
  gridKey,
  userDetail,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    {
      headerName: 'Document Name',
      field: 'name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 180 : 300,
      maxWidth: isSmallScreen ? 210 : 330,
      filter: true,
      type: 'text',
      pinned: 'left',
      lockPinned: true,
      lockPosition: true,
      suppressMenu: true,
      cellRenderer: DocumentName,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },

    {
      headerName: 'Status',
      field: 'status',
      minWidth: isSmallScreen ? 180 : 250,
      maxWidth: isSmallScreen ? 220 : 300,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        gridKey,
      },
      cellRenderer: ResponsiveFontsize,
    },
    {
      headerName: 'Document Type',
      field: 'document_type',
      minWidth: isSmallScreen ? 140 : 200,
      maxWidth: isSmallScreen ? 160 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        gridKey,
      },
      cellRenderer: DocumentTypeRenderer,
    },
    {
      headerName: 'Credit Deducted',
      field: 'credits_deducted',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      filter: true,
      type: 'text',
      suppressMenu: true,
      cellRenderer: CreditDeducted,
      minWidth: isSmallScreen ? 100 : 120,
      maxWidth: isSmallScreen ? 160 : 220,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Role',
      field: 'role',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        gridKey,
      },
      minWidth: isSmallScreen ? 100 : 120,
      maxWidth: isSmallScreen ? 160 : 220,
      cellRenderer: UserRole,
    },
    {
      headerName: 'Uploaded By',
      field: 'uploaded_by',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 200 : 250,
      maxWidth: isSmallScreen ? 250 : 300,
      resizable: false,
      cellRenderer: LastName,
      filter: true,
      type: 'text',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },

    {
      headerName: 'Uploaded At',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: date,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: ' ',
      field: ' ',
      resizable: false,
      minWidth: isSmallScreen ? 120 : 200,
    },
  ];
};

export default creditsHistoryColumnDef;
